import { memo, SVGProps } from 'react';

const BubbleBase = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 140 154' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M69.6421 143.872C108.104 143.872 139.284 111.665 139.284 71.9359C139.284 32.2068 108.104 0 69.6421 0C31.1798 0 6.10352e-05 32.2068 6.10352e-05 71.9359C6.10352e-05 95.7973 11.2473 116.945 28.5645 130.032L25.7634 152.097C25.6531 152.966 26.5998 153.571 27.3032 153.081L46.4198 139.775C53.683 142.428 61.4993 143.872 69.6421 143.872Z'
      fill='white'
    />
    <path
      d='M28.5645 130.032L30.5486 130.284L30.6945 129.134L29.7703 128.436L28.5645 130.032ZM25.7634 152.097L27.7475 152.349L27.7475 152.349L25.7634 152.097ZM27.3032 153.081L26.1607 151.44L26.1607 151.44L27.3032 153.081ZM46.4198 139.775L47.1059 137.897L46.13 137.54L45.2773 138.134L46.4198 139.775ZM137.284 71.9359C137.284 110.622 106.939 141.872 69.6421 141.872V145.872C109.269 145.872 141.284 112.708 141.284 71.9359H137.284ZM69.6421 2C106.939 2 137.284 33.2498 137.284 71.9359H141.284C141.284 31.1638 109.269 -2 69.6421 -2V2ZM2.00006 71.9359C2.00006 33.2498 32.345 2 69.6421 2V-2C30.0147 -2 -1.99994 31.1638 -1.99994 71.9359H2.00006ZM29.7703 128.436C12.9444 115.721 2.00006 95.1592 2.00006 71.9359H-1.99994C-1.99994 96.4353 9.55024 118.17 27.3587 131.627L29.7703 128.436ZM27.7475 152.349L30.5486 130.284L26.5804 129.78L23.7793 151.845L27.7475 152.349ZM26.1607 151.44C26.543 151.174 27.0111 151.225 27.3053 151.413C27.5936 151.598 27.7972 151.957 27.7475 152.349L23.7793 151.845C23.4709 154.274 26.1902 156.293 28.4458 154.723L26.1607 151.44ZM45.2773 138.134L26.1607 151.44L28.4458 154.723L47.5623 141.417L45.2773 138.134ZM69.6421 141.872C61.7375 141.872 54.1532 140.471 47.1059 137.897L45.7337 141.654C53.2128 144.386 61.2612 145.872 69.6421 145.872V141.872Z'
      fill='url(#paint0_linear_1382_1289)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1382_1289'
        x1={1.48798}
        y1={25.1189}
        x2={142.605}
        y2={63.8176}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#86DFF0' />
        <stop offset={0.687679} stopColor='#86DFF0' />
      </linearGradient>
    </defs>
  </svg>
);

const Memo = memo(BubbleBase);
export { Memo as BubbleBase };
